import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  listDemandSuppressionMasters,
  updateDemandSuppressionMaster,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 需要抑制計画マスタ 更新 mutation hook。
 * optimistic locking: expected_updated_at を request に含める。
 * onSuccess で listDemandSuppressionMasters を invalidate してテーブルを最新化する。
 */
export function useUpdateDemandSuppressionMaster(): InvalidatingMutationResultFor<
  typeof updateDemandSuppressionMaster
> {
  return useInvalidatingMutation(updateDemandSuppressionMaster, [
    createConnectQueryKey({
      schema: listDemandSuppressionMasters,
      cardinality: 'finite',
    }),
  ])
}
